var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canViewHorizontalNavMenuHeaderLink(_vm.item))?_c('li',{staticClass:"nav-item",class:{
    'sidebar-group-active active': _vm.isActive,
    'nav-item-right': _vm.item.alignRight
  }},[_c('b-link',_vm._b({staticClass:"nav-link"},'b-link',_vm.linkProps,false),[_c('feather-icon',{attrs:{"size":"14","icon":_vm.item.icon}}),_c('span',[_vm._v(_vm._s(_vm.t(_vm.item.title)))])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }